/* eslint-disable sonarjs/no-small-switch */
import React from 'react';
import {WidgetProps} from '@wix/yoshi-flow-editor';
import {IControllerProps} from '../../../types/app.types';
import CartApp from './CartApp/CartApp';
import {CartWidgetRoot} from '../../../common/components/CartWidgetRoot';
import {withExpressCheckoutButtons} from '@wix/ecom-platform-express-checkout-buttons/widget';
import {withSlotsPlaceholders} from '@wix/widget-plugins-ooi';

const CartAppRoot = (controllerProps: WidgetProps<IControllerProps>) => (
  <CartWidgetRoot controllerProps={controllerProps}>
    <CartApp host={controllerProps.host} ravenUserContextOverrides={{}} />
  </CartWidgetRoot>
);

export default withSlotsPlaceholders(withExpressCheckoutButtons(CartAppRoot));
